import { post, get, put, deleted, patch } from "../index";
import AuthRoutes from "./routes";

const AuthServices = {
  login: async (obj) => {
    const result = await post(AuthRoutes.login, obj);
    return result;
  },
  logout: async (obj) => {
    const result = await post(AuthRoutes.logout, obj);
    return result;
  },
  getTrains: async () => {
    const result = await get(AuthRoutes.getTrains);
    return result;
  },
  getTrainsById: async (id) => {
    const result = await get(AuthRoutes.getTrainsById + `?Id=${id}`);
    return result;
  },
  getLocomotive: async () => {
    const result = await get(AuthRoutes.getLocomotive);
    return result;
  },
  getLiveTrain: async () => {
    const result = await get(AuthRoutes.getLiveTrain);
    return result;
  },
  getStations: async () => {
    const result = await get(AuthRoutes.getStations);
    return result;
  },
  addStation: async (obj) => {
    const result = await post(AuthRoutes.addStation, obj);
    return result;
  },
  updateStation: async (obj) => {
    const result = await post(AuthRoutes.updateStation, obj);
    return result;
  },
  deleteStation: async (id) => {
    const result = await get(AuthRoutes.deleteStation + `?Id=${id}`);
    return result;
  },
  allocateLocomotive: async (obj) => {
    const result = await post(AuthRoutes.allocateLocomotive , obj);
    return result;
  },
  Complete: async (trainId,trainNumber,locomotiveNumber,trainRideId,rideCompleteDate,rideStatusId) => {
    const result = await get(AuthRoutes.Complete + `?trainId=${trainId}&trainNumber=${trainNumber}&locomotiveNumber=${locomotiveNumber}&trainRideId=${trainRideId}&rideCompleteDate=${rideCompleteDate}&rideStatusId=${rideStatusId}`);
    return result;
  },
  updateLocomotive: async (obj) => {
      const result = await post(AuthRoutes.updateLocomotive ,obj );
      return result;
    },
  allocateLocomotiveList: async () => {
    const result = await get(AuthRoutes.allocateLocomotiveList);
    return result;
  },
  deleteLocomotive: async (id) => {
    const result = await get(AuthRoutes.deleteLocomotive + `?Id=${id}`);
    return result;
  },
  allocationList: async (offset , limit) => {
    const result = await get(AuthRoutes.allocationList + `?offset=${offset}&limit=${limit}`);
    return result;
  },
  addLocomotive: async (obj) => {
    const result = await post(AuthRoutes.addLocomotive , obj);
    return result;
  },
  updatetTrainStatus: async (obj) => {
    const result = await post(AuthRoutes.updatetTrainStatus , obj);
    return result;
  },
  updateTrainById: async (obj) => {
    const result = await post(AuthRoutes.updateTrainById , obj);
    return result;
  },
  deleteTrain: async (id) => {
    const result = await get(AuthRoutes.deleteTrain + `?Id=${id}`);
    return result;
  },
  trainRoutes: async (id) => {
    const result = await get(AuthRoutes.trainRoutes + `?Id=${id}`);
    return result;
  },
  deleteTrainRoute: async (trainId ,stationId) => {
    const result = await get(AuthRoutes.deleteTrainRoute + `?Id=${trainId}&StationDetailId=${stationId}`);
    return result;
  },
  addTrain: async (obj) => {
    const result = await post(AuthRoutes.addTrain , obj);
    return result;
  },
  addTrainRoute: async (obj) => {
    const result = await post(AuthRoutes.addTrainRoute , obj);
    return result;
  },
  updateTrainRoute: async (obj) => {
    const result = await post(AuthRoutes.updateTrainRoute , obj);
    return result;
  },
  createNotification: async (obj) => {
    const result = await post(AuthRoutes.createNotification , obj);
    return result;
  },
  deleteNotification: async (trainId ,UserID) => {
    const result = await get(AuthRoutes.deleteNotification + `?Id=${trainId}&UserID=${UserID}`);
    return result;
  },
  getNotification: async (offset,limit) => {
    const result = await get(AuthRoutes.getNotification + `?offset=${offset}&limit=${limit}`);
    return result;
  },
  getAnalytics: async () => {
    const result = await get(AuthRoutes.getAnalytics);
    return result;
  },
  getDashboard: async () => {
    const result = await get(AuthRoutes.getDashboard);
    return result;
  },
};

export default AuthServices;
